

import React, { useState } from "react";
import { Play } from "lucide-react";
import image from "../assets/Founder.webp";
import our from "../assets/Journey.png"
import { Link } from "react-router-dom";

const AdminPortfolio = () => {
  const [playVideo, setPlayVideo] = useState(false);
  const videoId = "LsI9xlpr8D8"; 

  return (
    <div className="w-full">

      {/* ================= TOP SECTION ================= */}
      <section className="py-12 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">

          {/* Heading */}
          <h2 className="text-3xl md:text-4xl text-center font-serif mb-14 text-gray-800">
            Meet Our <span className="text-[#45A301]">Founder</span>
          </h2>
        <div className="grid md:grid-cols-2 gap-16 items-center">

    {/* IMAGE */}
    <div className="relative flex justify-center">
  
  {/* OUTER BORDER WRAPPER */}
  <div className="p-[10px] border-2 rounded-[30px] ">

    {/* IMAGE CARD */}
    <div className="relative w-full max-w-[410px] rounded-[24px] overflow-hidden bg-white">

      <img
        src={image}
        alt="founder"
        className="w-full h-full object-cover rounded-[24px]"
      />

      {/* NAME TAG */}
      <div className="absolute bottom-5 left-5 bg-white px-4 py-2 rounded-lg shadow text-sm">
        <p className="font-medium text-gray-800">Rajkumar</p>
        <p className="text-xs text-gray-500">Founder & Director</p>
      </div>

    </div>
  </div>

</div>

        {/* CONTENT */}
        <div className="max-w-xl">
          <div className="hidden md:block w-[2px] h-10 bg-[#45A301] mb-6"></div>

          <h3 className="text-2xl font-serif text-gray-800 mb-4">
            Our Beginning
          </h3>

          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Hello, my name is <span className="font-semibold text-black">Rajkumar</span>. I am originally from Tamil Nadu and
            currently engaged in real estate and agriculture-related
            businesses in the areas around Thekkady and Kumily in Idukki
            district, Kerala.
          </p>

          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Our journey began during my grandfather’s time, when he started
            clearing forest land in Idukki and began agricultural activities.
            During those days, Idukki was widely known as a prime region for
            <span className="font-semibold  text-black"> Cardamom </span> cultivation.
          </p>

          <p className="text-gray-600 text-sm leading-relaxed">
            Later, my father continued and expanded this work, strengthening
            our presence in agriculture. Following in their footsteps, I also
            entered the agriculture field and started documenting our farming
            journey and plantation work through YouTube.
          </p>
        </div>

        </div>
        </div>
      </section>

      {/* ================= BOTTOM SECTION ================= */}
      <section className="py-12 px-4 md:px-6">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
        
        {/* LEFT CONTENT */}
        <div className="max-w-xl">
          <p className="text-xs text-[#45A301] mb-3 bg-[#eef2e6] inline-block px-3 py-1 rounded-full">
            Our Digital Community
          </p>

          <h2 className="text-2xl md:text-3xl font-serif text-gray-800 mb-4">
            Documenting Our <br />
            <span className="text-[#45A301]">Plantation Journey</span>
          </h2>

          <p className="text-gray-600 text-sm mb-6 leading-relaxed">
            We started our YouTube channel to bridge the gap between
            traditional farming and modern real estate. What began as a way to
            document our daily operations on the cardamom estates has grown
            into a community of over 17,000 plantation enthusiasts and
            investors.
          </p>

          {/* Watch on YouTube Button */}
          <Link 
            to="https://youtube.com/@klpropertytamil?si=cZNZsRC_y7TPUR0e"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#45A301] w-fit text-white px-6 py-3 rounded-full text-sm flex items-center gap-2 hover:bg-[#3a8a01] transition-colors"
          >
            ▶ Watch Video
          </Link>

          {/* stats */}
          <div className="grid grid-cols-3 gap-6 mt-8 text-center text-sm">
            <div>
              <p className="font-semibold text-gray-800 text-lg">17K+</p>
              <p className="text-gray-500 text-xs">Subscribers</p>
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-lg">230+</p>
              <p className="text-gray-500 text-xs">Videos</p>
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-lg">1M+</p>
              <p className="text-gray-500 text-xs">Total Views</p>
            </div>
          </div>
        </div>

        {/* RIGHT VIDEO SECTION */}
        <div className="relative">
          <div className="rounded-2xl overflow-hidden shadow-2xl bg-black aspect-video md:h-[300px] w-full">
            {playVideo ? (
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            ) : (
              <div 
                className="relative cursor-pointer group w-full h-full"
                onClick={() => setPlayVideo(true)}
              >
                <img
                  src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                  alt="video thumbnail"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                
                {/* Custom Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="bg-white/90 p-5 rounded-full shadow-xl transform transition-transform group-hover:scale-110">
                    <Play className="text-[#45A301] fill-[#45A301]" size={32} />
                  </div>
                </div>

                {/* small badge */}
                <div className="absolute bottom-4 right-4 bg-black/70 text-white px-3 py-1 rounded-md text-xs backdrop-blur-sm">
                  Click to play
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    </section>

       {/* ================= Our Journey ================= */}
        <div className=" py-12">

      <div className="max-w-5xl mx-auto px-4 text-center">

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-serif text-gray-800 mb-3">
          Our Journey
        </h2>

        <p className="text-gray-500 text-sm mb-10">
          From the soil to the soul of Kerala real estate.
        </p>

        {/* Content */}
        <div className="text-left">

          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            From the early days of clearing forest land and developing plantations,
            our family laid a strong foundation in the fertile hills of Idukki.
            Through years of hard work, dedication, and deep understanding of the
            land, we gradually built a respected name in agriculture and land
            ownership across the region. Our journey is rooted in real experience
            on the ground from cultivating crops like cardamom and pepper to
            managing and maintaining productive plantation lands.
          </p>

          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            With this strong agricultural background and local knowledge, friends
            and well-wishers began approaching us for help in finding genuine and
            trustworthy land properties in and around Thekkady and Kumily. What
            started as a small effort to guide known contacts soon grew through word
            of mouth, trust, and successful transactions.
          </p>

          {/* Quote */}
          <div className="bg-[#F5F5F4] border-l-4 border-[#3D4F3D] p-5 mb-6">
            <p className="text-gray-700 text-sm italic">
              “We didn’t set out to be agents. We set out to be neighbors who knew
              the soil better than anyone else.”
            </p>
          </div>

          <p className="text-gray-600 text-sm leading-relaxed mb-12">
            Over time, this natural progression led to the formation of KL Property,
            a dedicated platform through which we now serve a wide range of clients
            from Tamil Nadu, Kerala, and other parts of India. Today, we continue to
            uphold the same values we started with: honesty, transparency, and a
            commitment to helping every customer find the right land with confidence
            and peace of mind.
          </p>

        </div>

        {/* Divider */}
        <div className="flex items-center justify-center gap-3 mb-12">
          <div className="h-[1px] w-16 bg-gray-300"></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
          <div className="h-[1px] w-16 bg-gray-300"></div>
        </div>

      </div>

      {/* Image */}
      <div className="max-w-5xl mx-auto px-4">
        <div className="rounded-2xl overflow-hidden shadow-md">
          <img
            src={our}
            alt="journey"
            className="w-full h-[220px] md:h-[320px] object-cover"
          />
        </div>
      </div>

    </div>
 
    </div>
  );
};

export default AdminPortfolio;